import clsx from "clsx"
import PropTypes from "prop-types"
import { Controller } from "react-hook-form"

const TextArea = ({ label, id, className, control, rows = 5, maxLength }) => {
  return (
    <Controller
      control={control}
      name={id}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => {
        return (
          <div
            className={clsx(
              "flex flex-col relative mb-4",
              className && className,
            )}
          >
            <div className="flex justify-between items-center">
              <label
                htmlFor={id}
                className="mt-4 mb-2 text-xs text-brand-secondary font-semibold"
              >
                {label}
              </label>
              {maxLength && (
                <div>
                  <span
                    className={clsx(
                      value?.length <= maxLength
                        ? "text-[green]"
                        : "text-[red]",
                    )}
                  >
                    {value?.length || 0}
                  </span>
                  /{maxLength}
                </div>
              )}
            </div>
            <textarea
              rows={rows}
              onChange={onChange}
              onBlur={onBlur}
              value={value || ""}
              id={id}
              type="text"
              className="bg-gray1 rounded-lg p-4"
            />
            {error && <p className="text-xs text-red-500">{error.message}</p>}
          </div>
        )
      }}
    />
  )
}

TextArea.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  control: PropTypes.object,
  errors: PropTypes.object,
}

export default TextArea
